<script setup lang="ts">
import { useC2cSellMachine } from './machine/useC2cSellMachine'
import OrderCreate from '~/components/order-create'
import {Modal} from 'ant-design-vue';
import {PromptModel} from '~/components/modal';

const isSameAddress = ref(false)
const { machine, states } = useC2cSellMachine()
const { refetch } = tronComp.useAccountCurrent()
const paymentResults = computed(() => {
  if (!machine.state.value)
    return undefined
  const { event } = machine.state.value
  console.log('event', event)
  const ref = {
    title: '',
    info: '',
  }
  if (!event.data)
    return undefined

  if (event.data.status === 6 || event.data.status === 15) {
    ref.title = $t('d7IRqXj60rtLFPOZm4hUI')
  }
  else if (event.data.status === 5) {
    ref.title = $t('d7IRqXj60rtLFPOZm4hUI')
    ref.info = $t('5qh1mLKZJRhuN2jfuToms')
  }
  else {
    return undefined
  }
  refetch()
  return ref
})
const prompt = ref(false)
watch(
  () => states.isSameAddress,
  () => {
    isSameAddress.value = states.isSameAddress
  },
)
watch(
  () => states.isConflict,
  (val) => {
    if (val) {
      prompt.value = true
    }
  },
)
function onUnRepeatExamine() {
  isSameAddress.value = false
  machine.send({
    type: 'DOUBLECHEC',
    skipDuplicateCheck: 1,
  })
}
</script>

<template>
  <!-- 出售弹窗集合 -->
  <div>
    <!-- 重复地址提示 start -->
    <AModal
      v-model:open="isSameAddress"
      wrapClassName="ant-cover__basic-modal"
      :footer="null"
      destroyOnClose
      :title="$t('44aFFKHXodPwuvI27f0Tw')"
      :maskClosable="false"
      @cancel="isSameAddress = false"
    >
      <div class="same-address-freeze-popup">
        <div class="content text-text text-md text-center">
          <span> {{ $t("yympMlpLi3j93VC5-dOVo") }} </span>
        </div>
        <div class="same-address-action flex gap-20px mt-30px">
          <AButton class="cancel-btn cancel flex-1" @click="states.isSameAddress = false" data-test-id="htny">
            {{ $t("r7f0icGNT568r4nfUjCNJ") }}
          </AButton>
          <AButton class="comfirm-btn pay-order flex-1" @click="onUnRepeatExamine" data-test-id="jb2q">
            {{ $t("UENBgObobQIqSj65k6uBN") }}
          </AButton>
        </div>
      </div>
    </AModal>
    <!-- 重复地址提示 end -->

    <!-- 出售中 start -->
    <AModal
      wrapClassName="ant-cover__basic-modal"
      :footer="null"
      :open="states.isRequest"
      :closable="false"
      :maskClosable="false"
      destroyOnClose
    >
      <OrderCreate />
    </AModal>
    <!-- 出售中 end -->

    <!-- 出售结果页 start -->
    <AModal
      wrapClassName="ant-cover__basic-modal"
      :footer="false"
      :open="states.showSellRefPopup"
      destroyOnClose
      :maskClosable="false"
      @cancel="machine.send('OK')"
    >
      <OrderResult
        :icon="paymentResults ? 'success' : 'error'"
        :title="paymentResults?.title"
        :subTitle="paymentResults?.info"
        @onClick="machine.send('OK')"
      />
    </AModal>
    <!-- 出售结果页 end -->

  <!-- 订单有更新提示 start -->
    <PromptModel v-model:open="prompt" :state="false" :content="$t('9wH_EgVSZ442WoIiYUUUU')" @close="machine.send('OK')" />
  <!-- 订单有更新提示 end -->
  </div>
</template>

<style lang="scss">
.ant-cover__basic-modal2.ant-cover__basic-modal{
  .ant-modal-confirm{
    .ant-modal-confirm-content{
      color: white;
    }
  }
}
</style>
